import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiHandler, CalendlyResponse } from '../handlers';

const BOOKED_MEETING_QUERY_KEY = 'bookedMeeting';

const bookedMeetingQueryFn = async (): Promise<
    CalendlyResponse | undefined
> => {
    const response = await ApiHandler.instance.donees.getBookedMeetingDetails();

    if (!response.success) {
        throw new Error('Failed to fetch booked meeting');
    }

    return response.response;
};

export const useBookedMeetingQuery = () => {
    return useQuery({
        queryKey: [BOOKED_MEETING_QUERY_KEY],
        queryFn: bookedMeetingQueryFn,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};

export const useRefreshBookedMeeting = () => {
    const queryClient = useQueryClient();

    return () =>
        queryClient.fetchQuery({
            queryKey: [BOOKED_MEETING_QUERY_KEY],
            queryFn: bookedMeetingQueryFn,
        });
};
